import Swiper from 'swiper'
import SwiperCore, { Navigation } from 'swiper/core'

SwiperCore.use([Navigation])

export default class ProductCrossSells {
  constructor(component) {
    this.dom = {
      $component: component,
      $section: component.querySelector('.js-ProductCrossSells'),
    }
    this.mount()
    this.bindToWindow()
  }

  mount() {
    this.loadProducts()
  }

  initSlider(container) {

    const { dom } = this
    new Swiper(container, {
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
      },
      slidesPerView: 1,
      navigation: {
        prevEl: dom.$component.querySelector('.js-productSliderPrev') || '',
        nextEl: dom.$component.querySelector('.js-productSliderNext') || '',
      },
    })
  }

  loadProducts() {
    const { dom } = this
    const mountCards = new Event('mountproductcards')
    const slides = window.basis.ProductCrossSells.slides
    const container = dom.$section.querySelector('.js-productThirdSliderContainer')
    container.querySelector('.swiper-wrapper').innerHTML = slides
    this.initSlider(container)
    this.setProductInfoHeight(container)
    document.dispatchEvent(mountCards)
  }

  setProductInfoHeight(container) {
    let tallestInfo = null
    const cardsInfo = container.querySelectorAll('.js-product-info')
    if (cardsInfo.length < 1) {
      return
    }

    Array.from(cardsInfo).forEach((info) => {
      if (!tallestInfo) {
        tallestInfo = info
        return
      }

      if (tallestInfo.clientHeight < info.clientHeight) {
        tallestInfo = info
      }
    })

    const paddingTop = parseInt(getComputedStyle(tallestInfo)?.paddingTop.replace('px', '')) || 0
    const newHeight = tallestInfo.clientHeight - paddingTop

    Array.from(cardsInfo).forEach((info) => {
      info.style.height = `${newHeight}px`
    })
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.ProductCrossSells = this
  }
}
